<template>
    <div>
        <div class="material-page" v-if="has_no_edit_material">
            <div class="material-page-content">
                <span>您的素材待修改快去看看吧</span>
                <el-button type="primary" size="mini" style="margin-left: 20px;" @click="handleClick">立即查看</el-button>
            </div>
        </div>
    </div>

</template>
<script>
import API from "@/api/workOrder/material.js"
export default {
    data() {
        return {
            msg: '',
            has_no_edit_material: false,
            clearID: ''
        }
    },
    mounted() {
        this.fetchMsg()
        // this.clearID = setInterval(()=>{
        //     this.fetchMsg()
        // }, 1000 * 5)
    },
    methods: {
        fetchMsg() {
            API.getWorkTaskMsg().then(res=>{
                this.has_no_edit_material = res.data.has_no_edit_material
            })
        },
        handleClick() {
            // this.has_no_edit_material = false
            this.$emit('msg-click')
        }
    },
    beforeDestroy() {
        clearInterval(this.clearID)
        for (let i = 0; i < 10; i++) {
            clearInterval(this.clearID)
        }
    }
}
</script>
<style lang="scss" scoped>
.material-page {
    background: #ffffff;
    padding: 10px 10px;
    border-radius: 4px;
    margin-bottom: 10px;
}
</style>
